module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan corps entier.b69fe28c.svg";